export var ITEMS_PER_PAGE = 10;
